<template>
    <div class="flex">
        <TabButton
            title="Catálogo"
            :active="selectedTab === 'products'"
            @click="() => onSelectTab('products')"
        />
        <TabButton
            title="Recompensas"
            :active="selectedTab === 'rewards'"
            @click="() => onSelectTab('rewards')"
        />
    </div>
    <ProductsList
        v-show="selectedTab === 'products'"
        :application="application"
        :productType="ProductType.FOR_SALE"
        :userBalance="userBalance"
        :giftTo="giftTo"
        :isCustomer="isCustomer"
    />
    <ProductsList
        v-show="selectedTab === 'rewards'"
        :application="application"
        :productType="ProductType.REWARD"
        :userBalance="userBalance"
        :giftTo="giftTo"
        :isCustomer="isCustomer"
    />
</template>
<script setup lang="ts">
type Tab = "products" | "rewards";

const selectedTab = ref<Tab>("products");
const { application, giftTo, userBalance, isCustomer } = defineProps<{
    application: IApplication;
    userBalance: number;
    giftTo?: IWallet;
    isCustomer?: boolean;
}>();

const onSelectTab = (tab: Tab) => {
    selectedTab.value = tab;
};
</script>
